import { Benefit } from '../../../@types/benefits';

export const benefitViewedStatusToApi = (benefit: Benefit) => ({
  type: `${benefit}_OVERVIEW_VIEWED`,
  page: 'BENEFITS_PAGE',
});
